import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

export default function ZocoCheckAlertsActionsMenu({
  item,
  disabled = false,
  onTake,
  onAssign,
  onRelease,
  onManage,
  onCopyMessage,
}) {
  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="link"
        className="zoco-check-alerts__kebab"
        disabled={disabled}
        aria-label={`Más acciones para ${item.commerceName}`}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
        {item.canTake ? <Dropdown.Item onClick={() => onTake?.(item)}>Tomar caso</Dropdown.Item> : null}
        {item.canAssign ? <Dropdown.Item onClick={() => onAssign?.(item)}>Asignar</Dropdown.Item> : null}
        {item.canRelease ? <Dropdown.Item onClick={() => onRelease?.(item)}>Liberar</Dropdown.Item> : null}
        <Dropdown.Item onClick={() => onManage?.(item)}>
          {item.isReadOnly || item.canManage === false ? "Ver detalles" : "Gestionar"}
        </Dropdown.Item>
        {item.suggestedMessage ? (
          <Dropdown.Item onClick={() => onCopyMessage?.(item.suggestedMessage)}>Copiar mensaje</Dropdown.Item>
        ) : null}
      </Dropdown.Menu>
    </Dropdown>
  );
}
